import React, { CSSProperties, FC, ReactNode } from 'react';
import { css } from '@emotion/css';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';
import clsx from 'clsx';

interface ParagraphProps extends CSSProperties {
  children: ReactNode;
  color?: 'dark' | 'middle' | 'light';
}

const Paragraph: FC<ParagraphProps> = (props) => {
  const { children, color, ...cssProps } = props;
  const theme = useTheme();
  const styles = createStyles(theme, { color });

  return <div className={clsx(styles.root, css({ ...cssProps }))}>{children}</div>;
};

const createStyles = (theme: Theme, { color = 'dark' }: Partial<ParagraphProps>) => ({
  root: css`
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    color: ${theme.colors.text[color]};
    ${theme.breakpoints.mobile.down} {
      font-size: 14px;
      line-height: 24px;
    }
  `,
});

export default Paragraph;
